import sanitizeHtml from 'sanitize-html'
import store from '@/store/index'
import moment from 'moment'

// для IOS такой способ форматировать даты не подходит, поэтому нужна проверка
const isIOS = () => {
  return store.getters.getUserAgent === 'IOS'
}

function formatDate (date) {
  if (!date) return ''

  if (isIOS()) {
    return date.slice(0, 10)
  }
  return moment(date)
    .locale('ru')
    .format('DD.MM.YYYY')
}

function formatTime (date) {
  if (!date) return ''
  return date.split(' ').pop().slice(0, 5)
}

function formatDateTime (date) {
  return `${formatDate(date)} ${formatTime(date)}`.trim()
}

// TODO: доработать функцию когда будут использовать ленту новостей на мобилке (форматит дату в мероприятиях перед отправкой на сервер)
export function formatDateForServer (date) {
  const newDate = new Date(date)
  const hours = newDate.getHours() < 10 ? `0${newDate.getHours()}` : newDate.getHours()
  const minutes = newDate.getMinutes() < 10 ? `0${newDate.getMinutes()}` : newDate.getMinutes()
  const formatDay = newDate.getDate() < 10 ? `0${newDate.getDate()}` : newDate.getDate()
  // +1 потому что отсчет месяцев начинается с нуля и до 11
  const formatMonth = newDate.getMonth() + 1 < 10 ? `0${newDate.getMonth() + 1}` : newDate.getMonth() + 1
  const year = newDate.getFullYear()
  return `${year}-${formatMonth}-${formatDay} ${hours}:${minutes}`
}

export function currentDate () {
  const today = new Date()
  const formatDay = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate()
  // +1 потому что отсчет месяцев начинается с нуля и до 11
  const formatMonth = today.getMonth() + 1 < 10 ? `0${today.getMonth() + 1}` : today.getMonth() + 1
  const year = today.getFullYear()
  return `${year}-${formatMonth}-${formatDay}`
}

export function currentDateTime () {
  const today = new Date()
  const formatDay = today.getDate() < 10 ? `0${today.getDate()}` : today.getDate()
  // +1 потому что отсчет месяцев начинается с нуля и до 11
  const formatMonth = today.getMonth() + 1 < 10 ? `0${today.getMonth() + 1}` : today.getMonth() + 1
  const year = today.getFullYear()
  const hours = today.getHours() < 10 ? `0${today.getHours()}` : today.getHours()
  const minutes = today.getMinutes() < 10 ? `0${today.getMinutes()}` : today.getMinutes()
  return `${year}-${formatMonth}-${formatDay} ${hours}:${minutes}`
}

export function currentTime () {
  const today = new Date()
  const hours = today.getHours() < 10 ? `0${today.getHours()}` : today.getHours()
  const minutes = today.getMinutes() < 10 ? `0${today.getMinutes()}` : today.getMinutes()
  return `${hours}:${minutes}`
}

// TODO: сделать форматирование дат для IOS более юзер френдли

// arrays compare
// простое сравнение массивов на наличие в массиве B элементов из A
export function arraysCompare (arrayA, arrayB) {
  if (arrayA.length !== arrayB.length) {
    return false
  }
  for (let i = 0; i < arrayA.length; i++) {
    if (!(arrayA.indexOf(arrayB[i]) + 1)) {
      return false
    }
  }
  return true
}

// clean html from disallowed tags
// isFull - флаг который позволит полностью очистить строку без исключений (нужно например для цитат)
// попутно заменяем неразрывные пробелы на обычные,
// чтобы в результате копипаста в поля ввода не рождались гиганские неразрывные строки
export function clearUserHtml (html, fullClear) {
  if (fullClear) {
    return sanitizeHtml(html, {
      allowedTags: ['br'],
      allowedAttributes: {}
    }).replace(/(?=\s)[^\r\n\t]/g, ' ')
      .replace(/<br[^>]*>/gi, '\n')
  } else {
    return sanitizeHtml(html, {
      allowedTags: ['a', 'br', 'div', 'p', 'b', 'small', 'img'],
      allowedAttributes: {
        a: ['href', 'title', 'target', 'style'],
        div: ['style'],
        b: ['style'],
        img: ['src']
      }
    }).replace(/(?=\s)[^\r\n\t]/g, ' ')
  }
}

export function arrayRandomize (array) {
  return array[Math.floor(Math.random() * array.length)]
}

export function debounce (func, wait, immediate) {
  let timeout

  return function executedFunction () {
    const context = this
    const args = arguments

    const later = function () {
      timeout = null
      if (!immediate) func.apply(context, args)
    }

    const callNow = immediate && !timeout

    clearTimeout(timeout)

    timeout = setTimeout(later, wait)

    if (callNow) func.apply(context, args)
  }
}

export {
  formatDate,
  formatTime,
  formatDateTime
}
